import type { ApiScheduledGame, GameStatus } from "../../../api";

const STATUS_TIERS: Record<GameStatus, number> = {
  in_progress: 0,
  about_to_start: 1,
  finished: 2,
  upcoming: 4,
};

export function compareGamesByStatusAndDate(
  left: Pick<ApiScheduledGame, "status" | "timestamp">,
  right: Pick<ApiScheduledGame, "status" | "timestamp">,
) {
  const hasSameStatus = left.status === right.status;

  if (hasSameStatus) {
    const leftStart = new Date(left.timestamp).getTime();
    const rightStart = new Date(right.timestamp).getTime();

    return leftStart - rightStart;
  }

  return STATUS_TIERS[left.status] - STATUS_TIERS[right.status];
}
